import { render, staticRenderFns } from "./VerifyYourEmail.vue?vue&type=template&id=1fe98252&scoped=true&"
import script from "./VerifyYourEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyYourEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyYourEmail.vue?vue&type=style&index=0&id=1fe98252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe98252",
  null
  
)

export default component.exports